import { AuthType } from '@/types/TAuth';
import apiClient from '@/utils/apiClient';

const SMS_PRICING_INFO_PATH = '/api/v2/receptionist-dashboard/sms-pricing-info';

/**
 * Fetches SMS pricing information by country and zone
 * @returns Promise with SMS pricing data including countries, zones, and metadata
 */
export const getSMSPricingInfo = async ({
	planId,
	clientType,
}: {
	planId?: string;
	clientType?: AuthType;
}) => {
	let queryParams = '';

	if (planId) {
		queryParams = `?planId=${planId}`;
	}

	const response = await apiClient.request({
		method: 'GET',
		endPoint: `${SMS_PRICING_INFO_PATH}${queryParams}`,
		clientType: clientType || 'RECEPTIONIST',
	});

	return response;
};
